import { render, staticRenderFns } from "./ControlTexto.vue?vue&type=template&id=5c0fa1d1&"
import script from "./ControlTexto.vue?vue&type=script&lang=js&"
export * from "./ControlTexto.vue?vue&type=script&lang=js&"
import style0 from "./ControlTexto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports